import { createContext } from 'react';

const MoveModeContext = createContext<boolean>(false);

export default MoveModeContext;
